import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltercontainerComponent } from './filtercontainer.component';



@NgModule({
  declarations: [
    FiltercontainerComponent
  ],
  exports:[FiltercontainerComponent],
  imports: [
    CommonModule
  ]
})
export class FiltercontainerModule { }
